import React, { useEffect } from "react";
import "./KnowAboutOrg.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

const KnowAboutOrg = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true
    });
  }, []);

  return (
    <section className="about_org_page">
      {/* TOP INTRO SECTION */}
      <div className="about_intro_block">
        <h1 className="about_title">
          {t('about_org.title_main')} <span>{t('about_org.title_brand')}</span>
        </h1>

        <p className="about_intro">
          {t('about_org.intro_text')}
        </p>
      </div>

      {/* ABOUT ORGANIZATION */}
      <section className="about_section about_org_layout" data-aos="fade-up">
        <div className="about_org_container">
          <div className="about_org_image">
            <div className="about_org_bg"></div>
            <img
              src={require("../../Asset/Images/MANAVTA.jpeg")}
              alt="About Organization"
            />
          </div>

          <div className="about_org_text">
            <h2>{t('about_org.section_about_title')}</h2>
            <p>{t('about_org.section_about_p1')}</p>
            <p>{t('about_org.section_about_p2')}</p>
            <p>{t('about_org.section_about_p3')}</p>
          </div>
        </div>
      </section>

      {/* FOUNDER / MANAGEMENT */}
      {/* FOUNDER / MANAGEMENT */}

<section className="about_section founder_section" data-aos="fade-up">

  <div className="founder_container">

    {/* TEXT */}

    <div className="founder_text">

      <h2>{t('about_org.founder_title')}</h2>
     <h4>{t('Headingg')}</h4>
     <h4>{t('Headingg2')}</h4>
     <p>{t('about_org.founder_p1')}</p>

    <p>{t('about_org.founder_p2')}</p>

    <p>{t('about_org.founder_p3')}</p>


    </div>

    {/* IMAGE */}

    <div className="founder_image">

      <div className="founder_bg"></div>

      <img
        src={require("../../Asset/Images/Mr.Choudhary.jpeg")}
        alt="Founder"
      />

    </div>

  </div>

</section>

      {/* SERVICES */}
      <section className="about_section services_section" data-aos="fade-up">
        <h2 className="services_title">{t('about_org.services_title')}</h2>
        <p className="services_intro">
          {t('about_org.services_intro')}
        </p>

        <div className="services_grid">
          {/* Healthcare */}
          <div className="service_card">
            <img
              src={require("../../Asset/Images/healthcaresupport.png")}
              alt="Healthcare Support"
            />
            <h3>{t('about_org.service_health_title')}</h3>
            <p>{t('about_org.service_health_desc')}</p>
          </div>

          {/* Meal Schedule */}
          <div className="service_card">
            <img
              src={require("../../Asset/Images/mealtime.png")}
              alt="Meal Schedule"
            />
            <h3>{t('about_org.service_meal_title')}</h3>
            <p>{t('about_org.service_meal_desc')}</p>
          </div>

          {/* Nutrition */}
          <div className="service_card">
            <img
              src={require("../../Asset/Images/nutrition.png")}
              alt="Nutritious Food"
            />
            <h3>{t('about_org.service_nutrition_title')}</h3>
            <p>{t('about_org.service_nutrition_desc')}</p>
          </div>

          {/* Personal Care */}
          <div className="service_card">
            <img
              src={require("../../Asset/Images/personalcare.png")}
              alt="Personal Care"
            />
            <h3>{t('about_org.service_personal_title')}</h3>
            <p>{t('about_org.service_personal_desc')}</p>
          </div>

          {/* Shelter */}
          <div className="service_card">
            <img
              src={require("../../Asset/Images/sheltersafety.png")}
              alt="Shelter and Safety"
            />
            <h3>{t('about_org.service_shelter_title')}</h3>
            <p>{t('about_org.service_shelter_desc')}</p>
          </div>
        </div>
      </section>

      {/* DOCUMENTS / LEGAL */}
      <section className="about_section" data-aos="fade-up">
        <h2>{t('about_org.docs_title')}</h2>
        <div className="docs_box">
          <ul>
            <li>{t('about_org.docs_list1')}</li>
            <li>{t('about_org.docs_list2')}</li>
            <li>{t('about_org.docs_list3')}</li>
            <li>{t('about_org.docs_list4')}</li>
            <li>{t('about_org.docs_list5')}</li>
            <li>{t('about_org.docs_list6')}</li>
            <li>{t('about_org.docs_list7')}</li>
            <li>{t('about_org.docs_list8')}</li>
          </ul>
        </div>
      </section>
    </section>
  );
};

export default KnowAboutOrg;